export enum BonusThresholdMetric {
  ItemCount = 'itemCount',
  Revenue = 'revenue',
}
